import moment from 'moment-timezone';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { useBounds } from 'hooks/useBounds';
import { useCurrencyFormatter } from 'hooks/useCurrencyFormatter';
import { ProductShape } from 'lib/util/productShape';
import { printPriceTitle } from 'lib/util/util';
import { getPromotionTitleText } from 'lib/util/promotionTextHelpers';

import baseStyles from '../base.module.css';
import styles from './ProductDetailsView.module.css';

interface Props {
  product: ProductShape;
}

export const PromotionDetailsView = ({ product }: Props) => {
  const { i18n, t } = useTranslation();

  const currencyFormatter = useCurrencyFormatter();

  const [promoListRef, promoListRefBounds] = useBounds<HTMLUListElement>();
  const [viewMore, setViewMore] = React.useState<boolean>(false);

  const locale = i18n ? i18n.language : '';

  const shouldTruncate = promoListRefBounds.height > 600;

  const containerDivClasses = ['c-promotion'];
  const buttonDivClasses = ['c-promotion__more'];
  if (shouldTruncate) {
    containerDivClasses.push(viewMore ? 'is-open' : 'is-close');
    buttonDivClasses.push(viewMore ? 'is-open' : 'is-close');
  }

  if (product.promotionSummaries.length === 0) {
    return null;
  }

  return (
    <section className={clsx(baseStyles['base-column__main__section'], styles['promotion'])}>
      <ul ref={promoListRef}>
        {product.promotionSummaries.map((promotion, idx) => {
          return (
            <li key={idx}>
              <div className={styles['promotion__item']}>
                <div className={styles['promotion__item__ttl']}>
                  <div className={styles['promotion__item__ttl__pic']}>
                    <img src="/static/images/ic_special.svg" />
                  </div>
                  <p className={styles['promotion__item__ttl__txt']}>
                    {getPromotionTitleText(promotion, t, locale, currencyFormatter)}
                  </p>
                </div>
                {/*
              <p className={styles["promotion__item__desc"]}>
                テキストが入ります。テキストが入ります。テキストが入ります。テキストが入ります。テキストが入ります。テキストが入ります。テキストが入ります。テキストが入ります。
              </p>
              */}
                <div
                  className={clsx(styles['promotion__item__date'], baseStyles['color-sub--txt'])}
                >
                  {(promotion.startDateLocalFrom || promotion.startDateLocalTo) && (
                    <p>
                      {' '}
                      {t(
                        'Participation Date: {{participationDateFrom}} ~ {{participationDateTo}}',
                        {
                          participationDateFrom: moment(promotion.startDateLocalFrom)
                            .locale(locale)
                            .format('ll'),
                          participationDateTo: moment(promotion.startDateLocalTo)
                            .locale(locale)
                            .format('ll'),
                        }
                      )}
                    </p>
                  )}
                  {(promotion.bookedDateLocalFrom || promotion.bookedDateLocalTo) && (
                    <p>
                      {t('Booked Date: {{bookedDateFrom}} ~ {{bookedDateTo}}', {
                        bookedDateFrom: moment(promotion.bookedDateLocalFrom)
                          .locale(locale)
                          .format('ll'),
                        bookedDateTo: moment(promotion.bookedDateLocalTo)
                          .locale(locale)
                          .format('ll'),
                      })}
                    </p>
                  )}
                </div>
                <div className={styles['promotion__item__price']}>
                  {promotion.prices
                    .filter((price) => price.amountAfterChargeOrDiscount !== price.amount)
                    .map((price) => (
                      <div className={styles['promotion__item__price__item']} key={price.unitTitle}>
                        <div className={styles['promotion__item__price__item__ttl']}>
                          {printPriceTitle(price, t)}
                        </div>
                        <div className={styles['promotion__item__price__item__right']}>
                          <div>
                            <p
                              className={clsx(
                                styles['promotion__item__price__item__right__label'],
                                baseStyles['color-main--bg']
                              )}
                            >
                              {(price.deltaPercent || price.deltaAmount) &&
                                (price.deltaType === 'CHARGE'
                                  ? t('+{{charge}}', {
                                      charge:
                                        price.deltaPercent ||
                                        currencyFormatter.format(price.deltaAmount),
                                    })
                                  : t('{{discount}} OFF', {
                                      discount:
                                        price.deltaPercent ||
                                        currencyFormatter.format(price.deltaAmount),
                                    }))}
                            </p>
                            <p
                              className={clsx(
                                styles['promotion__item__price__item__right__discount'],
                                baseStyles['color-main--txt']
                              )}
                            >
                              {currencyFormatter.format(price.amountAfterChargeOrDiscount)}
                            </p>
                          </div>
                          {price.amountAfterChargeOrDiscount !== price.amount && (
                            <p className={styles['promotion__item__price__item__right__normal']}>
                              {currencyFormatter.format(price.amount)}
                            </p>
                          )}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </li>
          );
        })}
      </ul>
      {shouldTruncate && (
        <div
          className={clsx(
            styles['promotion__more'],
            baseStyles['color-sub--txt'],
            baseStyles['color-sub--bor']
          )}
          onClick={() => setViewMore(!viewMore)}
        >
          <a>{viewMore ? t('Show Less') : t('Show More')}</a>
        </div>
      )}
    </section>
  );
};
